import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';

import { AlertType } from '../../../reducers/alert';
import { AlertSetting } from './AlertSetting/AlertSetting';

const AlertSettingLabel = {
    [AlertType.ALTITUDE]: 'messages.enableAltimeterReconciliation',
    [AlertType.FUEL]: 'messages.enableFuelReconciliation',
};

export const AlertSettings = ({ allowed, interval, onToggle, onChange }) => {
    const { t: translate } = useTranslation();

    return (
        <Grid container={true} direction="column">
            {Object.values(AlertType).map((type, i) => (
                <AlertSetting
                    key={i}
                    type={type}
                    label={translate(AlertSettingLabel[type])}
                    checked={allowed[type]}
                    value={interval[type]}
                    onToggle={onToggle}
                    onChange={onChange}
                />
            ))}
        </Grid>
    );
};
